var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pagination" }, [
    _c("div", { staticClass: "summary" }, [
      _c("p", { domProps: { innerHTML: _vm._s(_vm.resultCount) } }),
    ]),
    _vm._v(" "),
    _vm.last > 1
      ? _c(
          "div",
          { staticClass: "buttons" },
          [
            _c(
              "a",
              {
                class: 1 == _vm.current ? "disabled" : "",
                on: {
                  click: function ($event) {
                    return _vm.goTo(1)
                  },
                },
              },
              [_c("i", { staticClass: "fal fa-angle-double-left" })]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                class: 1 == _vm.current ? "disabled" : "",
                on: {
                  click: function ($event) {
                    _vm.goTo(Math.max(_vm.current - 1, 1))
                  },
                },
              },
              [_c("i", { staticClass: "fal fa-angle-left" })]
            ),
            _vm._v(" "),
            _vm._l(_vm.range, function (n) {
              return _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      return _vm.goTo(n)
                    },
                  },
                },
                [
                  _c("div", {
                    staticClass: "circular",
                    class: { active: n == _vm.current },
                    domProps: { textContent: _vm._s(n) },
                  }),
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "a",
              {
                class: _vm.last == _vm.current ? "disabled" : "",
                on: {
                  click: function ($event) {
                    _vm.goTo(Math.min(_vm.current + 1, _vm.last))
                  },
                },
              },
              [_c("i", { staticClass: "fal fa-angle-right" })]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                class: _vm.last == _vm.current ? "disabled" : "",
                on: {
                  click: function ($event) {
                    return _vm.goTo(_vm.last)
                  },
                },
              },
              [_c("i", { staticClass: "fal fa-angle-double-right" })]
            ),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }